import clsx from "clsx";
import { cn } from "@/core/helpers/cn";

type Props = {
  variant?: "green" | "lightBlue";
  className?: string;
};

export default function BadgeAvita({ variant = "green", className }: Props) {
  let background =
    "linear-gradient(56deg, rgba(18, 18, 18, 0.00) 30.07%, rgba(33, 101, 44, 0.60) 100%), linear-gradient(270deg, rgba(18, 18, 18, 0.60) 0%, rgba(18, 18, 18, 0.12) 100%)";
  if (variant === "lightBlue") {
    background =
      "linear-gradient(56deg, rgba(18, 18, 18, 0.00) 30.07%, rgba(1, 100, 172, 0.60) 100%), linear-gradient(270deg, rgba(18, 18, 18, 0.60) 0%, rgba(18, 18, 18, 0.12) 100%)";
  }

  return (
    <div
      className={cn(
        "absolute z-1 top-0 right-0 flex justify-center items-center w-[8.25rem] h-[4.75rem] rounded-bl-[10px] overflow-clip",
        className,
      )}
      style={{
        backdropFilter: "blur(4px)",
        background,
      }}
    >
      <div className="w-[5.125rem] h-9 mr-2.5 bg-[url(/svg/saleOnAvita.svg)] bg-cover bg-no-repeat bg-center" />
      <div className="absolute z-1 top-2 -right-1 flex gap-0.5 w-6.5 h-0.5 rotate-45">
        <div
          className={clsx(
            "w-[0.3125rem] h-0.5 rounded",
            { "bg-[#84FF97]": variant === "green" },
            { "bg-[#84E4FF]": variant === "lightBlue" },
          )}
        />
        <div
          className={clsx(
            "w-[0.3125rem] h-0.5 rounded",
            { "bg-[#84FF97]": variant === "green" },
            { "bg-[#84E4FF]": variant === "lightBlue" },
          )}
        />
        <div
          className={clsx(
            "w-[0.3125rem] h-0.5 rounded",
            { "bg-[#84FF97]": variant === "green" },
            { "bg-[#84E4FF]": variant === "lightBlue" },
          )}
        />
        <div
          className={clsx(
            "w-[0.3125rem] h-0.5 rounded",
            { "bg-[#84FF97]": variant === "green" },
            { "bg-[#84E4FF]": variant === "lightBlue" },
          )}
        />
      </div>
      <div
        className={clsx(
          "absolute top-5 -right-[7.85rem] w-45 h-8.5 bg-gradient-to-r rotate-45",
          {
            "from-[#368D44] to-[#21652C]": variant === "green",
          },
          {
            "from-[#007FDB] to-[#0164AC]": variant === "lightBlue",
          },
        )}
      />
    </div>
  );
}
